import { fireEventsOnServerRedirectTests } from "/services/new-ab-tests/new-ab-tests-service";

export const initBodyScripts = function({ abTests }) {
  fireEventsOnServerRedirectTests(abTests);
};
